/** Chart APIs may return null, [], or {} — treat only non-empty objects as data. */
export function hasChartRecordData(
  data: Record<string, string | number> | [] | null | undefined,
): boolean {
  if (!data || Array.isArray(data)) return false;
  return Object.values(data).some((v) => Number(v) > 0);
}

export function normalizeChartRecord(
  data: Record<string, string | number> | [] | null | undefined,
): Record<string, string> | null {
  if (!hasChartRecordData(data)) return null;
  const record = data as Record<string, string | number>;
  return Object.fromEntries(
    Object.entries(record).map(([k, v]) => [k, String(v)]),
  );
}
